import styled from 'styled-components';
import Table from 'components/ui/Table';
import { StyledTd } from 'components/ui/Table/Table.styles';
import { colours, common, fonts } from 'themes/default';
import { LinkButton } from 'components/ui/Button';
import { BREAKPOINTS } from 'constants/breakpoints';

import eurostarLogo from 'assets/rebrand/logos/eurostar.svg';

const { fontStyleRegular } = fonts;

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const StyledLinkButton = styled(LinkButton)`
  padding: 0;
  margin: 0;
  font-weight: normal;
  text-decoration: none;
`;

export const StyledArrowContainer = styled.span`
  margin-left: 4px;
  margin-top: 2px;
  transform: ${({ isOpened }) => (isOpened ? 'rotate(-90deg)' : 'rotate(90deg)')};
`;

export const StyledTable = styled(Table)`
  width: 100%;
  table-layout: fixed;
  border-spacing: 0px;
  tbody {
    tr {
      td {
        border-color: ${colours.Greyscale.SilverGrey};
        border-width: 1px;
        border-style: solid;
        ${fontStyleRegular}
      }
      td:first-child {
        border-width: 1px 0px 1px 2px;
      }
      td:nth-child(2) {
        border-width: 1px 0px 1px 0px;
      }
      td:nth-child(3) {
        border-width: 1px 3px 1px 0px;
        border-right-color: black;
      }
      td:last-child {
        border-width: 1px 2px 1px 1px;
      }
    }

    tr[data-highlighted] td:first-child {
      background-color: ${common.notifications.alert.backgroundColour};
      border-left-color: ${common.notifications.alert.borderColour};
    }
  }

  ${StyledTd} {
    height: 25px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    thead th:nth-child(-n + 3) {
      width: 13%;
    }
  }
`;

export const StyledJourneyDetailsContainer = styled.div`
  font-size: 10px;

  ol {
    padding: 0;
    margin: 0;
  }

  *:before {
    box-sizing: border-box;
  }

  li > div {
    .MuiGrid-item {
      position: relative;

      > div {
        &:before {
          border-color: ${common.genericUiHighlightColour};
        }

        > div {
          font-size: 16px;

          &:before {
            border-color: ${common.genericUiHighlightColour};
          }
        }

        > span {
          font-size: 14px;
        }
      }

      svg {
        fill: ${common.genericUiHighlightColour};
      }

      &[data-replace-service-icon="ES"],
      &[data-replace-service-icon="ER"] {
        img {
          opacity: 0;
        }

        &::after {
          background-color: ${colours.Greyscale.White};
          background-image: url("${eurostarLogo}");
          background-repeat: no-repeat;
          background-size: clamp(75px, 75%, 100px);
          background-position: top right;
          content: '';
          display: block;
          height: 100%;
          left: 0;
          position: absolute;
          top: 0;
          width: 100%;
        }
      }
    }

    .MuiGrid-item > span > div {
      font-size: 14px;
    }

    eurostarLogo
  }
`;

export const CenteredText = styled.span`
  text-align: center;
`;

export const SearchResultsContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const StyledSearchDiv = styled('div')`
  border: solid #eee 2px;
  box-sizing: border-box;
  width: 100%;
`;

export const StyledTrainNumber = styled.span`
  white-space: nowrap;

  ${({ disabled }) =>
    disabled
      ? `
      text-decoration: none;
      cursor: default;
      pointer-events: none;
    `
      : `
        cursor: pointer;
        text-decoration: underline;
    `}
`;

export const StyledAvailabilities = styled.div`
  margin: 4px;
`;

export const StyledDepartureTime = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledTrainOccupancyButton = styled.button`
  display: flex;
  background: none;
  border: 0;
  cursor: pointer;
  padding: 0;

  svg {
    width: 20px;
    height: 20px;
  }

  ${({ $isERTrain }) =>
    $isERTrain &&
    `
    .c-seat .c-seat__seat-element,
    .c-seat:hover .c-seat__seat-element {
      color: ${colours.Core.SecondaryPlum};
    }
  `}
`;
